<template lang="pug">
  div.deal-lost-integrations
    .form
      .form-group
        .row.description
          label
            strong {{ $t('integrations.title.deal_lost') }}:

        .form-group
          .row
            .checkbox-inline.checkbox-update(@click="sending_checked('update_deal_lost')")
              input(type='checkbox', name='mark_as', :checked='update_deal_lost')
              label {{ $t('integrations.actions.update.deal_lost.update') }}

          .row
            .checkbox-inline.checkbox-update(@click="sending_checked('not_update_deal_lost')")
              input(type='checkbox', name='mark_as', :checked='not_update_deal_lost')
              label {{ $t('integrations.actions.update.deal_lost.notUpdate') }}

</template>

<script>
const helpers = require('../../../helpers.coffee')

let view_model = {
  props: ['settings', 'on_responsibility'],

  data () {
    return {
      mark_as: null,
      not_update_deal_lost: false,
      update_deal_lost: false
    }
  },

  methods: {
    sending_checked(option) {
      if(option === 'update_deal_lost') {
        this.update_deal_lost = !this.update_deal_lost
        this.not_update_deal_lost = !this.update_deal_lost

        this.mark_as = 'update_deal_lost'
        this.$emit('selected', this.mark_as)
      } else if(option === 'not_update_deal_lost') {
        this.not_update_deal_lost = !this.not_update_deal_lost
        this.update_deal_lost = !this.not_update_deal_lost

        this.mark_as = 'not_update_deal_lost'
        this.$emit('selected', this.mark_as)
      }
    }
  },

  created() {
    if(this.settings === 'update_deal_lost')
      this.update_deal_lost = true
    else
      this.not_update_deal_lost = true
  }
}

exports.default = helpers.vue_include(view_model, helpers.form)
</script>

<style lang="sass" scoped>

@import '../../../assets/stylesheets/_variables.sass'

.deal-lost-integrations
  padding-bottom: 10px

.description
  padding: 5px 20px 0px 0px
  text-align: left

.left
  padding-left: 0px
  padding-right: 0px

.leftadd
  padding-left: 0px
  padding-right: 0px
  float:left

.toggler-inline
  padding: 7px 0 0 15px
  text-align: left

.checkbox-update
  float: left
  padding: 12px 12px 12px 0px

.indice
    float: none
    color: $dark-slate-gray
    font-size: .9em
    text-align: left
    margin-bottom: 25px
    &.indice-plus
      margin-top: 15px
</style>



// WEBPACK FOOTER //
// deal_lost.vue?44d5cde8